import React from 'react';

export const SelectorAmbitoLegal = ({ opciones, ambitoActivo, onElegirAmbito, colores }) => {
  const estiloDeOpcion = (esOpcionActiva) => {
    if (!esOpcionActiva) return { color: colores.colorPrincipal };
    return { color: colores.color6, backgroundColor: colores.colorPrincipal, borderColor: colores.colorPrincipal };
  };

  return (
    <div className='legal-ambitos'>
      <span className='legal-ambitos-titulo'>Ámbito</span>
      <div className='legal-ambitos-opciones'>
        {opciones.map(({ ambito, nombre, tieneTextoPropio }) => {
          const esOpcionActiva = ambito === ambitoActivo;
          return (
            <button
              key={ambito}
              type='button'
              className='legal-ambito'
              aria-pressed={esOpcionActiva}
              style={estiloDeOpcion(esOpcionActiva)}
              onClick={() => onElegirAmbito(ambito)}
            >
              {nombre}
              {tieneTextoPropio && <span className='legal-ambito-marca'>Texto propio</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
};
